import { createBrowserRouter, Navigate } from 'react-router-dom';

import {
  MAIN_PAGE,
  ABOUT_COMPANY_PAGE,
  SUPPORT_PAGE,
  CONTACTS_PAGE,
  PROJECTS_PAGE,
  PROJECT_STATUS_PAGE,
  CONSTRUCTION_PROGRESS_PAGE,
  BUSINESS_PROJECT_PAGE,
  PARKING_PROJECT_PAGE,
  PROMO_PAGE,
  MORTGAGE_PAGE,
  FLATS_PAGE,
  COMPARE_PAGE,
  FAVORITE_PAGE,
  NEWS_PAGE,
  CAREERS_PAGE,
  VACANCY_DETAILS_PAGE,
  EXCURSIONS_PAGE,
  MANAGEMENT_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
  FLAT_PAGE,
  BUSINESS_CARD_PAGE,
  PARKING_CARD_PAGE,
  PARKING_PAGE,
  BUSINESS_PAGE,
  PURCHASE_FLAT_PAGE,
  PURCHASE_BUSINESS_PAGE,
  PURCHASE_PARKING_PAGE,
  AGREEMENT_PAGE,
} from './paths';

import MainPage from '../pages/MainPage/MainPage';
import PromoPage from '../pages/PromoPage/PromoPage';
import AboutCompanyPage from '../pages/AboutCompanyPage/AboutCompanyPage';
import SupportPage from '../pages/SupportPage/SupportPage';
import ContactsPage from '../pages/ContactsPage/ContactsPage';
import ProjectsPage from '../pages/ProjectsPage/ProjectsPage';
import BusinessProjectPage from '../pages/BusinessProjectPage/BusinessProjectPage';
import MortgagePage from '../pages/MortgagePage/MortgagePage';
import NotFoundPage from '../pages/NotFoundPage/NotFoundPage';
import FlatsPage from '../pages/FlatsPage/FlatsPage';
import FavoritePage from '../pages/FavoritePage/FavoritePage';
import ComparePage from '../pages/ComparePage/ComparePage';
import NewsPage from '../pages/NewsPage/NewsPage';
import CareersPage from '../pages/CareersPage/CareersPage';
import VacancyDetailsPage from '../pages/VacancyDetailsPage/VacancyDetailsPage';
import ExcursionsPage from '../pages/ExcursionsPage/ExcursionsPage';
import ManagementPage from '../pages/ManagementPage/ManagementPage';
import PrivacyPage from '../pages/PrivacyPage/PrivacyPage';
import TermsPage from '../pages/TermsPage/TermsPage';
import NewPage from '../pages/NewPage/NewPage';
import FlatCardPage from '../pages/FlatCardPage/FlatCardPage';
import BusinessCardPage from '../pages/BusinessCardPage/BusinessCardPage';
import ParkingCardPage from '../pages/ParkingCardPage/ParkingCardPage';
import ParkingProjectPage from '../pages/ParkingProjectPage/ParkingProjectPage';
import ProjectStatusPage from '../pages/ProjectStatusPage/ProjectStatusPage';
import ConstructionProgressPage from '../pages/ConstructionProgressPage/ConstructionProgressPage';
import BusinessPage from '../pages/BusinessPage/BusinessPage';
import ParkingPage from '../pages/ParkingPage/ParkingPage';
import PurchaseFlatPage from '../pages/PurchaseFlatPage/PurchaseFlatPage';
import PurchaseBusinessPage from '../pages/PurchaseBusinessPage/PurchaseBusinessPage';
import PurchaseParkingPage from '../pages/PurchaseParkingPage/PurchaseParkingPage';
import AgreementPage from '../pages/AgreementPage/AgreementPage';

export const router = createBrowserRouter([
  {
    path: MAIN_PAGE,
    element: <MainPage />,
  },
  {
    path: ABOUT_COMPANY_PAGE,
    element: <AboutCompanyPage />,
  },
  {
    path: SUPPORT_PAGE,
    element: <SupportPage />,
  },
  {
    path: CONTACTS_PAGE,
    element: <ContactsPage />,
  },
  {
    path: PROJECTS_PAGE,
    element: <ProjectsPage />,
  },
  {
    path: PROJECT_STATUS_PAGE,
    element: <ProjectStatusPage />
  },
  {
    path: CONSTRUCTION_PROGRESS_PAGE,
    element: <ConstructionProgressPage />
  },
  {
    path: '/flat',
    element: <Navigate to='/projects' replace />,
  },
  {
    path: BUSINESS_PROJECT_PAGE,
    element: <BusinessProjectPage />,
  },
  {
    path: PARKING_PROJECT_PAGE,
    element: <ParkingProjectPage />,
  },
  {
    path: PROMO_PAGE,
    element: <PromoPage />,
  },
  {
    path: MORTGAGE_PAGE,
    element: <MortgagePage />,
  },
  {
    path: FLATS_PAGE,
    element: <FlatsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
  {
    path: FAVORITE_PAGE,
    element: <FavoritePage />,
  },
  {
    path: COMPARE_PAGE,
    element: <ComparePage />,
  },
  {
    path: NEWS_PAGE,
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewPage />,
  },
  {
    path: CAREERS_PAGE,
    element: <CareersPage />,
  },
  {
    path: VACANCY_DETAILS_PAGE,
    element: <VacancyDetailsPage />,
  },
  {
    path: EXCURSIONS_PAGE,
    element: <ExcursionsPage />,
  },
  {
    path: MANAGEMENT_PAGE,
    element: <ManagementPage />,
  },
  {
    path: PRIVACY_PAGE,
    element: <PrivacyPage />,
  },
  {
    path: TERMS_PAGE,
    element: <TermsPage />,
  },
  {
    path: FLAT_PAGE,
    element: <FlatCardPage />,
  },
  {
    path: BUSINESS_CARD_PAGE,
    element: <BusinessCardPage />
  },
  {
    path: PARKING_CARD_PAGE,
    element: <ParkingCardPage />
  },
  {
    path: BUSINESS_PAGE,
    element: <BusinessPage />,
  },
  {
    path: PARKING_PAGE,
    element: <ParkingPage />,
  },
  {
    path: PURCHASE_FLAT_PAGE,
    element: <PurchaseFlatPage />,
  },
  {
    path: PURCHASE_BUSINESS_PAGE,
    element: <PurchaseBusinessPage />,
  },
  {
    path: PURCHASE_PARKING_PAGE,
    element: <PurchaseParkingPage />,
  },
  {
    path: AGREEMENT_PAGE,
    element: <AgreementPage />,
  },
]);
